// MA-28 — founder analytics route (under /parent gate; NOT in settings SECTIONS nav).
// Direct URL: /parent/analytics
import { createFileRoute } from "@tanstack/react-router";
import { FounderAnalytics } from "@/screens/FounderAnalytics";
export const Route = createFileRoute("/parent/analytics")({
  component: FounderAnalytics,
});
